import { render, staticRenderFns } from "./ocs.vue?vue&type=template&id=0d9303af&scoped=true&"
import script from "./ocs.vue?vue&type=script&lang=js&"
export * from "./ocs.vue?vue&type=script&lang=js&"
import style0 from "./ocs.vue?vue&type=style&index=0&id=0d9303af&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d9303af",
  null
  
)

export default component.exports